// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___vFNrO","error":"error___px4aS","root":"root___ufkry","error_style":"error_style___lCVXl"};